/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressBook,
    AddressBookFromJSON,
    AddressBookFromJSONTyped,
    AddressBookToJSON,
    Asset,
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    DiscordInfo,
    DiscordInfoFromJSON,
    DiscordInfoFromJSONTyped,
    DiscordInfoToJSON,
    PhoneNumber,
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserType,
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    XpMultiplier,
    XpMultiplierFromJSON,
    XpMultiplierFromJSONTyped,
    XpMultiplierToJSON,
} from './';

/**
 * 
 * @export
 * @interface StandardAdmin
 */
export interface StandardAdmin extends User {
}

export function StandardAdminFromJSON(json: any): StandardAdmin {
    return StandardAdminFromJSONTyped(json, false);
}

export function StandardAdminFromJSONTyped(json: any, ignoreDiscriminator: boolean): StandardAdmin {
    return json;
}

export function StandardAdminToJSON(value?: StandardAdmin | null): any {
    return value;
}


